import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Checkbox extends PureComponent {
  render() {
    const { className, ...others } = this.props;
    const cls = classNames({
      "weui-check": true
    }, className);

    return (
      <>
        <input className={ cls } type="checkbox" { ...others } />
        <i className="weui-icon-checked"></i>
      </>
    );
  }
}
